export function extractYearSet(obj) {
    const years = new Set();
    Object.values(obj || {}).forEach(metric => {
        Object.keys(metric || {}).forEach(k => years.add(k));
    });
    return years;
}

export function normalizeYears(rawYears, limit = null) {
    const numeric = rawYears
        .filter(y => /^\d{4}$/.test(y))
        .map(Number)
        .sort((a, b) => a - b)
        .map(String);
    const ttm = rawYears.includes('TTM');
    const limited = limit && numeric.length > limit ? numeric.slice(-limit) : numeric;
    return { numeric: limited, ttm };
}

export function buildDisplayHeadersFromSet(yearSet, limit = null) {
    const { numeric, ttm } = normalizeYears(Array.from(yearSet), limit);
    const latest = numeric[numeric.length - 1];
    const headers = numeric.map(y => `Mar${y}`);
    if (ttm && latest) headers.push(`TTM ${Number(latest) + 1}`);
    return { headers, orderedKeys: numeric.concat(ttm ? ['TTM'] : []) };
}

export function formatRatioYears(values, limit = null) {
    const raw = values.map(v => String(v.year));
    const { numeric, ttm } = normalizeYears(raw, limit);
    const latest = numeric[numeric.length - 1];
    const ordered = numeric.concat(ttm ? ['TTM'] : []);
    return ordered.map(y => {
        const src = values.find(v => String(v.year) === y) || {};
        let displayYear = /^\d{4}$/.test(y) ? `Mar${y}` : y;
        if (y === 'TTM' && latest) displayYear = `TTM ${Number(latest) + 1}`;
        return { ...src, year: y, displayYear };
    });
}

export function normalizeYearKey(raw) {
    if (raw == null) return null;
    const str = String(raw).trim();
    if (!str) return null;
    if (/^TTM/i.test(str)) return 'TTM';
    const match = str.match(/(19|20)\d{2}/);
    return match ? match[0] : (/^\d{4}$/.test(str) ? str : null);
}